import mitt from "mitt"

type Events = {
    NEXT: void
}

const GAME_EMITTER = mitt<Events>()

export default GAME_EMITTER
